import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '@trashlab/sitesapp/src/routes/__root';
import { DumpsterSizesHeroSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-sizes/dumpster-sizes-hero-section';
import { DumpsterSizesIntro } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-sizes/dumpster-sizes-intro';
import { DumpsterSizesCards } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-sizes/dumpster-sizes-cards';
import { WhichSizeSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-sizes/which-size-section';
import { WeightLimitsSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-sizes/weight-limits-section';
import { FaqSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-sizes/faq-section';
import { NotSureCtaSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/dumpster-sizes/not-sure-cta-section';
import { ReadyWhenYouAre } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/ready-when-you-are';
import { ServiceAreasSection } from '@trashlab/sitesapp/src/organizations/redebins/template/components/shared/service-areas-section';

const DumpsterSizesPage = () => {
  return (
    <>
      <DumpsterSizesHeroSection />
      <DumpsterSizesIntro />
      <DumpsterSizesCards />
      <WhichSizeSection />
      <WeightLimitsSection />
      <FaqSection />
      <NotSureCtaSection />
      <ReadyWhenYouAre />
      <ServiceAreasSection />
    </>
  );
};

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/dumpster-sizes',
  component: DumpsterSizesPage,
});
